import { ONE_MINS } from '../utils/const';
var HornLite = /** @class */ (function () {
    function HornLite(ctx, storage, hornConfigGetter) {
        this.ctx = ctx;
        this.storage = storage;
        this.hornConfigGetter = hornConfigGetter;
        this.isInit = false;
    }
    HornLite.prototype.init = function (params, options) {
        var _a;
        var opt = {
            isDev: false,
            disableRegister: false,
            ignoreStorageError: false,
            sankuaiOnly: false,
            host: null,
        };
        if (typeof options === 'boolean') {
            opt.isDev = options;
        }
        else if (typeof options === 'object') {
            opt.disableRegister = !!options.disableRegister;
            opt.ignoreStorageError = !!options.ignoreStorageError;
            opt.isDev = !!options.isDev;
            opt.sankuaiOnly = !!options.sankuaiOnly;
            opt.host = (_a = options.host) !== null && _a !== void 0 ? _a : null;
        }
        this.ctx.init(params, opt);
        this.isInit = true;
    };
    HornLite.prototype.setParams = function (params) {
        this.ctx.setParams(params);
    };
    /**
     * 直接请求一次配置，如果缓存有效，则走缓存
     * @param key horn 配置的 key
     * @param query 配置查询参数
     * @param defaultValue 可选参数，如果传了此参数，则在异常时候自动返回 defaultValue，如果不传，需要手动 catch 异常
     */
    HornLite.prototype.fetch = function (key, query, defaultValue) {
        if (!this.isInit) {
            throw new Error('调用 fetch 需要先 init');
        }
        var promise = this._fetchCore(key, query).then(function (r) { return r.metaData.customer; });
        if (defaultValue) {
            return promise.catch(function () {
                return defaultValue;
            });
        }
        return promise;
    };
    /** 根据 Horn 发布配置来决定更新缓存还是删除 */
    HornLite.prototype._freshCache = function (configMetaData) {
        // 是否需要更新缓存
        if (configMetaData.horn.cacheDuration <= 0) {
            // 由于发布配置设定了不缓存, 所以找到之前缓存并清除
            return this.storage.remove(configMetaData.hornId);
        }
        else {
            // 刷新缓存, 并延长缓存时间
            return this.storage.set(configMetaData.hornId, configMetaData, new Date(Date.now() + ONE_MINS * 0.1 + configMetaData.horn.cacheDuration * ONE_MINS).getTime());
        }
    };
    HornLite.prototype._fetchCore = function (hornId, params) {
        var _this = this;
        // 先判断是否有本地缓存
        return this.storage.getWithExpires(hornId).then(function (rawMetaDataFromCache) {
            var metaDataFromCache = rawMetaDataFromCache === null || rawMetaDataFromCache === void 0 ? void 0 : rawMetaDataFromCache.originValue;
            // 有缓存 且缓存没有过期情况, 直接使用缓存的值
            if (rawMetaDataFromCache && Date.now() < rawMetaDataFromCache.expireTime) {
                return Promise.resolve({
                    metaData: metaDataFromCache,
                });
            }
            // 当缓存过期时候走网络请求拉取配置
            var ETagFromCache = metaDataFromCache === null || metaDataFromCache === void 0 ? void 0 : metaDataFromCache.etag;
            return _this.hornConfigGetter
                .getSingleConfigInfo(hornId, ETagFromCache, params)
                .then(function (ret) {
                // 无论协商缓存是否生效 都刷新缓存
                var metaData = ret || metaDataFromCache;
                // 缓存起来
                return _this._freshCache(metaData).then(function () {
                    return {
                        metaData: metaData,
                    };
                });
            });
        });
    };
    return HornLite;
}());
export default HornLite;
//# sourceMappingURL=HornLite.js.map